/**
 * Where docs/onboarding videos live (plan §3).
 *
 *   <base>/<id>/<id>.web.mp4   1080p30, what the app plays
 *   <base>/<id>/<id>.mp4       1440p60, the larger view
 *   <base>/<id>/<id>.jpg       poster
 *   <base>/<id>/<id>.en.vtt    captions (narrated clips only)
 *
 * `REACT_APP_VIDEO_BASE_URL` overrides the base for local review; the default
 * is the DigitalOcean Space behind cdn.apiboo.com. The desktop CSP admits it
 * in `media-src` (video) and `img-src` (poster).
 */
export const DEFAULT_VIDEO_BASE_URL = 'https://media.apiboo.com/assets/videos';

export function videoBaseUrl() {
  const fromEnv = process.env.REACT_APP_VIDEO_BASE_URL;
  const base = fromEnv && fromEnv.trim() ? fromEnv.trim() : DEFAULT_VIDEO_BASE_URL;
  return base.replace(/\/+$/, '');
}

const SUFFIX = {
  web: '.web.mp4',
  full: '.mp4',
  poster: '.jpg',
  captions: '.en.vtt',
};

/**
 * @param {string} id    video id, kebab-case (e.g. `variables`)
 * @param {'web'|'full'|'poster'|'captions'} kind
 */
export function videoUrl(id, kind = 'web') {
  const suffix = SUFFIX[kind];
  if (!suffix) throw new Error(`videoUrl: unknown kind "${kind}"`);
  const safe = String(id || '').replace(/[^a-z0-9-]/gi, '');
  return `${videoBaseUrl()}/${safe}/${safe}${suffix}`;
}

/**
 * A screenshot referenced as `shot:<id>` in the docs Markdown. DOCS_CONTRACT:
 * `<videoBase>/../shots/<id>.webp`.
 */
export function shotUrl(id) {
  const safe = String(id || '').replace(/[^a-z0-9-]/gi, '');
  const root = videoBaseUrl().replace(/\/[^/]*$/, ''); // `<base>/..`
  return `${root}/shots/${safe}.webp`;
}
